import Id from './Id';
import Status from './Status';
import Supplier from './Supplier';
import TargetStorage from './TargetStorage';
import SourceStorage from './SourceStorage';
import ReceiptNumber from './ReceiptNumber';
import Customer from './Customer';
import Created from './Created';
import Updated from './Updated';

export const labels = {
  Id: 'Id',
  ReceiptNumber: 'Bizonylatszám',
  Status: 'Státusz',
  Supplier: 'Átadó',
  SourceStorage: 'Forrás raktár',
  TargetStorage: 'Cél raktár',
  Customer: 'Átvevő',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'Supplier',
}, {
  value: 'Customer',
}, {
  value: 'SourceStorage',
}, {
  value: 'TargetStorage',
}, {
  value: 'Created',
}, {
  value: 'Updated',
}, {
  value: 'Status',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'Supplier',
}, {
  value: 'Customer',
}, {
  value: 'SourceStorage',
}, {
  value: 'TargetStorage',
}, {
  value: 'Created',
}, {
  value: 'Updated',
}, {
  value: 'Status',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'ascending'
};

export default {
  Id,
  ReceiptNumber,
  Status,
  Supplier,
  SourceStorage,
  TargetStorage,
  Customer,
  Created,
  Updated,
};
